module.exports = __webpack_public_path__ + "static/img/guidance14.6e0a4852.png";